import CustomAccordian from "../../components/CustomAccordian";
import CustomButton from "../../components/CustomButton";
import { useState } from "react";
import '../../assets/css/SearchFilter.css';
import { useNavigate } from "react-router-dom";


const SearchFilter = () => {
  const [location, setLocation] = useState("Profile Location");
  const [distance, setDistance] = useState(25);
  const [isSearchForStringer, setIsSearchForStringer] = useState(false);
  const Navigate = useNavigate();

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };

  const handleDistanceChange = (e) => {
    setDistance(e.target.value);
  };

  const [selectedLevels, setSelectedLevels] = useState(['Intermediate']);
  const [selectedLevelSpotrs, setSelectedLevelSpotrs] = useState();
  const [ageRange, setAgeRange] = useState([15, 25]);

  const levels = [
    'Beginner',
    'Intermediate',
    'Upper-Intermediate',
    'Proficient',
    'League Player'
  ];
  const sports = [
    'Tennis',
    'Pickle Ball'
  ];
  const genders = [
    'Mail',
    'Femail',
    'Others'
  ]


  const handleCheckboxChange = (level) => {
    setSelectedLevels(prevSelected => {
      if (prevSelected?.includes(level)) {
        return prevSelected.filter(item => item !== level);
      } else {
        return [...prevSelected, level];
      }
    });
  };


  const handleMinChange = (e) => {
    const minValue = parseInt(e.target.value, 10);
    setAgeRange([Math.min(minValue, ageRange[1] - 1), ageRange[1]]);
  };

  const handleMaxChange = (e) => {
    const maxValue = parseInt(e.target.value, 10);
    setAgeRange([ageRange[0], Math.max(maxValue, ageRange[0] + 1)]);
  };

  const handleCheckboxChangeSports = (level) => {
    setSelectedLevelSpotrs(prevSelected => {
      if (prevSelected?.includes(level)) {
        return prevSelected?.filter(item => item !== level);
      } else {
        return [...prevSelected, level];
      }
    });
  };

  const accordionItems = [
    {
      title: 'Location And Distance',
      content: <div className="container mt-4 p-4 border rounded">
        <h5 className="fw-bold pb-2">Location</h5>
        <div className="form-check pb-1">
          <input
            className="form-check-input"
            type="radio"
            name="location"
            id="profileLocation"
            value="Profile Location"
            checked={location === "Profile Location"}
            onChange={handleLocationChange}
          />
          <label className="form-check-label" htmlFor="profileLocation">
            Profile Location <span className="text-muted">New York City</span>
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="location"
            id="currentLocation"
            value="Current Location"
            checked={location === "Current Location"}
            onChange={handleLocationChange}
          />
          <label className="form-check-label" htmlFor="currentLocation">
            Current Location <span className="text-muted">Queens City</span>
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="location"
            id="otherLocation"
            value="Other"
            checked={location === "Other"}
            onChange={handleLocationChange}
          />
          <label className="form-check-label" htmlFor="otherLocation">
            Other <span className="text-muted">(select to search new location)</span>
          </label>
        </div>

        <h5 className="fw-bold mt-4">Distance</h5>
        <div className="d-flex align-items-center">
          <input
            type="range"
            className="form-range-single"
            min="0"
            max="100"
            value={distance}
            onChange={handleDistanceChange}
          />
          <span className="ms-2 badge bg-primary">{distance}</span>
        </div>
      </div>,
    },
    {
      title: 'Levels',
      content: <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Levels</h5>
          <form>
            {levels.map((level) => (
              <div key={level} className="form-check mb-2 pb-1">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`level-${level}`}
                  checked={selectedLevels.includes(level)}
                  onChange={() => handleCheckboxChange(level)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`level-${level}`}
                >
                  {level}
                </label>
              </div>
            ))}
          </form>
        </div>
      </div>,
    },
    {
      title: 'Sports',
      content:
        <div className="card shadow-sm" >
          <div className="card-body">
            <h5 className="card-title mb-3">Levels</h5>
            <form>
              {sports?.map((level) => (
                <div key={level} className="form-check mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`level-${level}`}
                    checked={selectedLevelSpotrs?.includes(level)}
                    onChange={() => handleCheckboxChangeSports(level)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`level-${level}`}
                  >
                    {level}
                  </label>
                </div>
              ))}
            </form>
          </div>
        </div>
      ,
    },
    {
      title: 'Gender',
      content: <div className="card shadow-sm" >
        <div className="card-body">
          <h5 className="card-title mb-3">Levels</h5>
          <form>
            {genders?.map((level) => (
              <div key={level} className="form-check mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`level-${level}`}
                  checked={selectedLevelSpotrs?.includes(level)}
                  onChange={() => handleCheckboxChangeSports(level)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`level-${level}`}
                >
                  {level}
                </label>
              </div>
            ))}
          </form>
        </div>
      </div>,
    },
    {
      title: 'Age Range',
      content:
        <>
          <div className="container mt-4">
            <h5>Age Range</h5>
            <div className="slider-container">
              {/* Circles with Values Above the Slider */}
              <div className="slider-labels">
                <div
                  className="slider-circle"
                  style={{
                    left: `${(ageRange[0] / 100) * 100}%`,
                  }}
                >
                  {ageRange[0]}
                </div>
                <div
                  className="slider-circle"
                  style={{
                    left: `${(ageRange[1] / 100) * 100}%`,
                  }}
                >
                  {ageRange[1]}
                </div>
              </div>

              {/* Two Range Inputs */}
              <div className="position-relative">
                <input
                  type="range"
                  className="form-range"
                  min="0"
                  max="100"
                  value={ageRange[0]}
                  onChange={handleMinChange}
                />
                <input
                  type="range"
                  className="form-range"
                  min="0"
                  max="100"
                  value={ageRange[1]}
                  onChange={handleMaxChange}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between w-100 mt-3">
            <div className="age-input">{ageRange[0]} yr</div>
            <div className="age-input">{ageRange[1]} yr</div>
          </div>
        </>,
    },
  ];
  const onApplyFilter = () => {
    Navigate('./playerlist')
  }
  return (
    <>
      <div className="d-flex justify-content-center align-items-center" >
        <div className="container border p-4" style={{ width: '50%', margin: '10px' }}>
          <div className="row">
            <div className="d-flex justify-content-between  p-4">
              <div style={{ color: '#006FFD', fontWeight: '600' }}>Cancel</div>
              <div style={{ color: '#1F2024', fontWeight: '600' }}>Filter</div>
              <div style={{ color: '#FF616D', fontWeight: '600' }}>Clear All</div>
            </div>
            <div className="text-end">
              <div className="form-check form-switch d-flex justify-content-end pb-3">
                <label className="form-check-label pe-5" htmlFor="flexSwitchCheckDefault">
                  Search for Stringer
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  checked={isSearchForStringer}
                  onChange={(e) => setIsSearchForStringer(e.target.checked)}
                />
              </div>
            </div>

            <div>
              <CustomAccordian
                items={isSearchForStringer ? [accordionItems[0]] : accordionItems}
              />
            </div>
            <div className="pt-3 pb-2">
              <CustomButton buttonText={'ApplyFilter'} className="custom-search-filter-btn px" onClick={onApplyFilter} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default SearchFilter;